import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,InputGroup, Input,InputGroupAddon, Label } from 'reactstrap';
import FacebookLogin from 'react-facebook-login';

import GlobalStorage from '../storage/GlobalStorage'
import AppZipCreator from'../../AppZipCreator'
import AppConnector from '../../AppConnector'
import axios from 'axios'


export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {
      
    }    
  }

  
  


  render()
  {
    return (
      <div>
        <ModalHeader toggle={()=>{this.props.toggleModal()}}>為方便聯絡，作者必須提交電郵。</ModalHeader>
        <ModalBody>
          <InputGroup>
            <InputGroupAddon addonType="prepend">@</InputGroupAddon>
            <Input 
              id="email" 
              placeholder="電郵地址" 
              //value="kwongsham@gmail.com"
            />
          </InputGroup>                                    
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={()=>{
            let GS = new GlobalStorage();    
    
            let api_url;
            
              
              
              
                    
              api_url = global.API_URL+'readers/updateReader';
        
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            
            if (re.test(document.getElementById("email").value)){
              axios({
                method: 'patch',
                url: api_url,
                data:{email:document.getElementById("email").value},
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: GS.getUser().token,
                }
              })
              .then(response => {
                GS.getUser().reader.email=document.getElementById("email").value;
                if (GS.getStoryEpisode().coverImage==null && GS.getStoryEpisode().coverImageURL==null)
                {
                  alert("請先選擇章節封面");
                  this.props.toggleModalState('createEpisode',2);
                  this.props.toggleModal(true);
                }else
                {
                  new AppZipCreator().createEpisode(()=>{
                    alert("你的故事一般會在十五分鐘後上架。");
                  });
                }
              })
              .catch(error => {
                    
              });              
            }else{
              alert("請輸入有效電郵！");              
            }
          }}>提交</Button>{' '}              
        </ModalFooter>
      </div>
    )
  }
}